export enum ValidationResult {
  Valid,
  NoInput,
  InvalidNumber,
  InvalidRange
}
